"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M57.3232 49.8687V20.2823V17.416H32.057L24.5618 9.89219H2.09521V49.8687H57.3232Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#FFF",
    opacity: 0.88,
    d: "M57.3232 49.8687V20.2823V17.416H32.057L24.5618 9.89219H2.09521V49.8687H57.3232Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M22.8211 11.25L29.223 17.652C29.9262 18.3551 30.8801 18.75 31.875 18.75H54.375C55.4109 18.75 56.25 19.5891 56.25 20.625V46.875C56.25 47.9109 55.4109 48.75 54.375 48.75H5.625C4.58906 48.75 3.75 47.9109 3.75 46.875V13.125C3.75 12.0891 4.58906 11.25 5.625 11.25H22.8211ZM5.625 7.5C2.51836 7.5 0 10.0184 0 13.125V46.875C0 49.9816 2.51836 52.5 5.625 52.5H54.375C57.4816 52.5 60 49.9816 60 46.875V20.625C60 17.5184 57.4816 15 54.375 15H31.875L25.473 8.59805C24.7699 7.89492 23.816 7.5 22.8211 7.5H5.625Z"
  })));
};
var _default = exports.default = SvgFolder;